










































































declare var daum: any;

import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import StorageService from "@/mixins/StorageService";
import ParkingLotView from "@/components/ParkingLotView.vue";
import UtilsService from "@/mixins/UtilsService";
import { api } from "@/models/api-path.model";
import { InScopeParkinglot } from "@/models/parkinglot.model";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import { Action } from "vuex-class";

// import { getIsAdministrator } from "@/features/accounts";

function debounce(fn: Function, delay: number) {
  let timer: any;

  return function() {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn();
    }, delay);
  } as any;
}

@Component({
  components: {
    ParkingLotView,
    PulseLoader,
  },
})
export default class Map extends Mixins(StorageService, UtilsService) {
  @Prop()
  regist!: boolean;

  @Action("closeDialog", { namespace: "dialog" }) closeDialog!: any;
  @Action("showConfirm", { namespace: "dialog" }) showConfirm!: any;
  @Action("showAlert", { namespace: "dialog" }) showAlert!: any;

  map: any; // 다음 지도 api
  geocoder: any; // 다음 주소 위치 api
  marker: any; // 선택한 지점 마커 api
  markers: any[]; // 아이파킹 마커리스트
  address: any;
  parkinglot: any;
  myMarker: any; // 현재 내위치 마커
  infowindow: any; // 다음 정보 창
  infowindowArray: any[];
  position: any;
  searchAddrInfo: any;
  addrText: string;
  mapMaxLevel: number;
  watchId: number | null;
  geoOptions: any;
  myCenter: any;
  userId: string;
  isSendMarker: boolean;
  mapParkingLotList!: InScopeParkinglot[]; // 인근주차장 리스트 ++
  color: string = "white";

  debounceGetIparking = debounce(this.getIparkingPark, 1000);
  isCheckPermission = window.localStorage.getItem("level"); // '0': 일반사용자, '1': 관리자

  constructor() {
    super();

    this.mapParkingLotList = []; // 인근주차장 리스트 초기값
    this.markers = [];
    this.infowindowArray = [];
    this.marker = null;
    this.myMarker = null;
    this.infowindow = null;
    this.position = {
      latitude: 37.5663176911,
      longitude: 126.9778283816,
    };
    this.searchAddrInfo = {
      road_address: null,
      address: null,
    };
    this.addrText = "";
    // this.mapMaxLevel = 4;
    this.geoOptions = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 180000,
    };
    this.parkinglot = null;
    this.address = null;

    this.userId = this.getStorage("local", "id");
    this.mapMaxLevel = this.isCheckPermission === "1" ? 10 : 4;

    this.myCenter = {
      latitude: this.position.latitude,
      longitude: this.position.longitude,
    };

    this.watchId = null;
    this.isSendMarker = true;
  }

  mounted() {
    this.disabledScroll();
    this.initMap();
    // this.getIparkingPark();
  }

  destroyed(): void {
    this.activationScroll();
    this.closeDialog();
  }

  closeMap(): void {
    this.watchId != null ? navigator.geolocation.clearWatch(this.watchId) : "";
    this.$emit("close");
  }

  // get isAdministrator(): boolean {
  //   return getIsAdministrator(this.userId);
  // }

  getAddress(): void {
    if (!this.parkinglot && !this.address) {
      this.showAlert({
        message: "선택된 주소가 없습니다.",
      });
      return;
    }

    if (!this.regist && this.isSendMarker) {
      this.showAlert({
        message:
          "주차장 정보 수정 시에는<br>다른 마커 정보를 가져올 수 없습니다.",
      });
      return;
    }
    this.watchId != null ? navigator.geolocation.clearWatch(this.watchId) : "";
    this.$emit(
      "close",
      this.isSendMarker
        ? Object.assign({ send_marker: true }, this.parkinglot)
        : Object.assign({ send_marker: false }, this.address)
    );
  }

  initMap(): void {
    const container = document.getElementById("mapContainer");

    const options = {
      center: new daum.maps.LatLng(
        this.position.latitude,
        this.position.longitude
      ),
      level: 3,
      disableDoubleClick: false,
      disableDoubleClickZoom: false,
    };

    this.map = new daum.maps.Map(container, options);
    this.map.setMaxLevel(this.mapMaxLevel);
    this.geocoder = new daum.maps.services.Geocoder();

    this.map.setDraggable(false);
    this.map.setZoomable(false);

    if (this.isCheckPermission !== "1") {
      // gps 잡기 전까지 드래그 및 줌 아웃 방지
      // this.map.setDraggable(false);
      // this.map.setZoomable(false);

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position: any) => {
          this.position = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          };

          this.map.setDraggable(false);
          this.map.setZoomable(true);
        });
        // 지도 키고 이동시 위치 체크
        this.watchId = navigator.geolocation.watchPosition(
          (position: any) => {
            this.removeMyMarker();
            this.position = {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            };

            // 현재위치 마크
            const markerPosition = new daum.maps.LatLng(
              position.coords.latitude,
              position.coords.longitude
            );
            this.myMarker = new daum.maps.Marker({
              position: markerPosition,
              zIndex: 999,
            });

            this.map.setCenter(markerPosition);

            this.myMarker.setMap(this.map);

            this.myCenter = {
              latitude: this.map.getCenter().getLat(),
              longitude: this.map.getCenter().getLng(),
            };

            if (this.markers.length === 0) {
              this.debounceGetIparking();
            }
          },
          (error: any) => {
            switch (error.code) {
              case error.PERMISSION_DENIED:
                this.showAlert({
                  message: "위치 정보 활용 동의가 필요합니다.",
                  callbackFn: () => {
                    this.closeMap();
                  },
                });
                break;

              case error.POSITION_UNAVAILABLE: // 포지션 정보를 확인할 수 없음
              case error.TIMEOUT: // 위치정보 캣치 시간 초과
                this.showAlert({
                  message:
                    "위치 정보를 확인할 수 없습니다.\n 다시 시도해 주세요.",
                  callbackFn: () => {
                    this.closeMap();
                  },
                });
                break;

              case error.UNKNOWN_ERROR:
                this.showAlert({
                  message: "알 수 없는 에러가 발생 했습니다.",
                  callbackFn: () => {
                    this.closeMap();
                  },
                });
                break;
            }
          },
          this.geoOptions
        );
      } else {
        this.showAlert({
          message: "GPS 사용 동의가 필요합니다.",
          callbackFn: () => {
            this.closeMap();
          },
        });
      }
    } else {
      this.map.setDraggable(true);
      this.map.setZoomable(true);
      this.getIparkingPark();
    }

    /**
     * @description 드래그가 끝날 때 발생한다.
     */
    daum.maps.event.addListener(this.map, "dragend", () => {
      this.boundCheck();
    });

    /**
     * bounds_changed
     * 바운드가 변경했을 때 이벤트

    daum.maps.event.addListener(this.map, 'bounds_changed', function () {
      // this.boundCheck();
    });*/

    /**
     * @description 지도를 클릭했을때 클릭한 위치에 마커를 추가하도록 지도에 클릭이벤트를 등록합니다
     */
    daum.maps.event.addListener(this.map, "click", (mouseEvent: any) => {
      // 클릭한 위치에 마커를 표시합니다
      this.clickMap(mouseEvent);
    });
  }

  /**
   * @method getIparkingPark
   * @description 아이파킹 주차장 등록 데이터 호출
   */
  getIparkingPark() {
    this.removeMarkers();
    this.removeInfowindow();

    const centerLatlng = this.map.getCenter();
    const maxMeter = this.isCheckPermission === "1" ? 1000 : 400;
    const maxLat = this.getMaxLatitude(maxMeter);
    const maxLng = this.getMaxLongitude(maxMeter, centerLatlng.getLat());

    const lat_start = centerLatlng.getLat() - maxLat;
    const lat_end = centerLatlng.getLat() + maxLat;
    const lng_start = centerLatlng.getLng() - maxLng;
    const lng_end = centerLatlng.getLng() + maxLng;

    const params = {
      latitude_start: lat_start,
      latitude_end: lat_end,
      longitude_start: lng_start,
      longitude_end: lng_end,
    };

    this.$http.get(api.parkinglotImportIparkingList, { params: params }).then(
      (resp) => {
        const { code, data, message, error } = resp.data;

        if (error) {
          this.showAlert({
            message: error,
          });
          return;
        }

        if (code !== 20000 && code !== 40001) {
          this.showAlert({
            message: message,
          });
          return;
        }
        this.addMarkers(data);
      },
      (error) => {
        this.showAlert({
          message: error,
        });
      }
    );
  }

  getListInScope() {
    const centerLatlng = this.map.getCenter();
    const maxMeter = 100;
    const maxLat = this.getMaxLatitude(maxMeter);
    const maxLng = this.getMaxLongitude(maxMeter, centerLatlng.getLat());

    const lat_start = centerLatlng.getLat() - maxLat;
    const lat_end = centerLatlng.getLat() + maxLat;
    const lng_start = centerLatlng.getLng() - maxLng;
    const lng_end = centerLatlng.getLng() + maxLng;

    const params = {
      latitude_start: lat_start,
      latitude_end: lat_end,
      longitude_start: lng_start,
      longitude_end: lng_end,
    };

    this.$http.get(api.parkinglotListInScope, { params: params }).then(
      (resp) => {
        const { code, data, message, error } = resp.data;

        this.mapParkingLotList = <InScopeParkinglot[]>data;
      },
      (error) => {}
    );
  }

  /**
   * @method addMarker
   * @description 아이파킹 등록 주차장 마커
   */
  addMarkers(data: any[]) {
    this.markers = this.initMarker(data);
  }

  /**
   * @method initMarker
   * @description 마커 정보를 미리 세팅하여 반환
   */
  initMarker(data: any[]): any[] {
    const contractMarker = require("@/assets/images/map-marker-parking.svg");
    const nomarlMarker = require("@/assets/images/map-marker-normal.svg");

    const imageSize = new daum.maps.Size(40, 42); // 마커이미지의 크기입니다
    const imageOption = { offset: new daum.maps.Point(11, 41) }; // 마커이미지의 옵션입니다. 마커의 좌표와 일치시킬 이미지 안에서의 좌표를 설정합니다.

    return data.reduce((acc: any, cur: any) => {
      let markerImage;
      let content =
        '<div style="padding:1px; font-size:13px; width:100%; text-align:center;">';

      markerImage = new daum.maps.MarkerImage(
        cur.parkinglot_type === 1 ? contractMarker : nomarlMarker,
        imageSize,
        imageOption
      );
      // 마커를 클릭했을 때 마커 위에 표시할 인포윈도우를 생성합니다
      content += cur.paclname
        ? cur.paclname
        : cur.parkname +
          "<br>" +
          cur.address_1 +
          " " +
          cur.address_2 +
          "</div>"; // 인포윈도우에 표출될 내용으로 HTML 문자열이나 document element가 가능합니다

      const markerPosition = new daum.maps.LatLng(cur.latitude, cur.longitude);
      const addMarker = new daum.maps.Marker({
        position: markerPosition,
        image: markerImage,
        clickable: true,
        zIndex: 800,
      });

      addMarker.setMap(this.map);

      // 인포윈도우를 생성합니다
      const infowindow = new daum.maps.InfoWindow({
        content: content,
        removable: false, // removeable 속성을 ture 로 설정하면 인포윈도우를 닫을 수 있는 x버튼이 표시됩니다
        zIndex: 999,
      });

      // 마커에 클릭이벤트를 등록합니다
      daum.maps.event.addListener(addMarker, "click", (event: any) => {
        this.isSendMarker = true;
        this.removeInfowindow();
        this.removeSelectMarker();

        this.geocoder.coord2Address(
          Number(cur.longitude),
          Number(cur.latitude),
          (result: any, status: any) => {
            if (status === daum.maps.services.Status.OK) {
              let roadAddress: any = null;
              if (result[0].road_address) {
                roadAddress = result[0].road_address;
              }
              const address = result[0].address;
              const region: Array<string> = [];

              if (roadAddress) {
                const zip_code = roadAddress.zone_no
                  ? roadAddress.zone_no
                  : roadAddress.zip_code
                  ? roadAddress.zip_code
                  : "";
                region.push(roadAddress.region_1depth_name);
                region.push(roadAddress.region_2depth_name);
                region.push(zip_code);
              } else {
                region.push(address.region_1depth_name);
                region.push(address.region_2depth_name);
                region.push(address.zip_code);
              }

              Object.assign(cur, { zipcode: region[2] });

              infowindow.open(this.map, addMarker);

              this.infowindowArray.push(infowindow);
              this.parkinglot = cur;
              this.registerCheck(cur.seq);
            }
          }
        );
      });

      acc.push(addMarker);
      return acc;
    }, []);
  }

  /**
   * @method clickMap
   * @description 맵을 선택 시
   */
  clickMap(mouseEvent: any) {
    this.removeSelectMarker();
    this.removeInfowindow();

    const latlng = mouseEvent.latLng;

    this.geocoder.coord2Address(
      latlng.getLng(),
      latlng.getLat(),
      (result: any, status: any) => {
        if (status === daum.maps.services.Status.OK) {
          let roadAddress = null;
          if (result[0].road_address) {
            roadAddress = result[0].road_address;
          }
          const address = result[0].address;
          this.drowMarker(address, roadAddress, latlng);
          this.getListInScope();
        }
      }
    );
  }

  /**
   * @method findAddress
   * @description 주소 검색 시 위치 찾기
   */
  findAddress() {
    this.removeSelectMarker();
    this.removeInfowindow();

    if (this.addrText !== "") {
      this.geocoder.addressSearch(this.addrText, (result: any, status: any) => {
        if (status === daum.maps.services.Status.OK) {
          let roadAddress = null;
          if (result[0].road_address) {
            roadAddress = result[0].road_address;
          }
          const address = result[0].address;

          this.drowMarker(
            address,
            roadAddress,
            new daum.maps.LatLng(Number(result[0].y), Number(result[0].x)),
            true
          );
          this.getIparkingPark();
        } else {
          this.showAlert({
            message: "해당 주소가 존재하지 않습니다.",
          });
        }
      });
    }
  }

  /**
   * @method getMaxLatitude
   * @argument meter 최대 범위
   */
  private getMaxLatitude(meter: number): number {
    return meter / 111320;
  }

  /**
   * @method getMaxLongitude
   * @argument meter 최대 범위
   * @argument lat 위도
   */
  private getMaxLongitude(meter: number, lat: number): number {
    return meter / ((40075000 * Math.cos(lat)) / 360);
  }

  /**
   * @method sendData
   * @description 주소 정보 전달 또는 주차장 정보 전달
   */
  sendData() {
    /*
    const readyData = this.mapService.getMapData();

    if (Object.keys(readyData.address).length > 0 || Object.keys(readyData.ipaking).length > 0) {
      // this.mapService.setViewMode(false);
      // this.mapService.setData();
    } else {
      return alert('위치를 선택 또는 주차장을 선택 후 눌러주세요.');
    }*/
  }

  private drowMarker(
    address: any,
    roadAddress: any,
    latlng?: any,
    center?: boolean
  ) {
    this.isSendMarker = false;
    const clickMarker = require("@/assets/images/map-marker-pic.svg");
    const imageSize = new daum.maps.Size(40, 42); // 마커이미지의 크기입니다
    const imageOption = { offset: new daum.maps.Point(11, 41) }; // 마커이미지의 옵션입니다. 마커의 좌표와 일치시킬 이미지 안에서의 좌표를 설정합니다.
    const markerImage = new daum.maps.MarkerImage(
      clickMarker,
      imageSize,
      imageOption
    );
    const markerPosition = new daum.maps.LatLng(
      latlng.getLat(),
      latlng.getLng()
    );

    this.marker = new daum.maps.Marker({
      position: markerPosition,
      image: markerImage,
      zIndex: 999,
    });

    if (center) {
      this.map.setCenter(markerPosition);
    }

    this.marker.setMap(this.map);

    this.searchAddrInfo.road_address = roadAddress
      ? roadAddress.address_name
      : null;
    this.searchAddrInfo.address = address ? address.address_name : null;

    let content = '<div style="padding:1px;font-size: 12px;width: 110%">';
    if (address && roadAddress) {
      content +=
        roadAddress.address_name + "<br>(" + address.address_name + ")</div>";
    } else if (address && !roadAddress) {
      content += address.address_name + "</div>";
    } else if (!address && roadAddress) {
      content += roadAddress.address_name + "</div>";
    }

    // 인포윈도우를 생성합니다
    this.infowindow = new daum.maps.InfoWindow({
      content: content,
      removable: false, // removeable 속성을 ture 로 설정하면 인포윈도우를 닫을 수 있는 x버튼이 표시됩니다
      zIndex: 999,
    });

    this.infowindow.open(this.map, this.marker);

    const region: Array<string> = [];

    if (roadAddress) {
      const zip_code = roadAddress.zone_no
        ? roadAddress.zone_no
        : roadAddress.zip_code
        ? roadAddress.zip_code
        : "";
      region.push(roadAddress.region_1depth_name);
      region.push(roadAddress.region_2depth_name);
      region.push(zip_code);
    } else {
      region.push(address.region_1depth_name);
      region.push(address.region_2depth_name);
      region.push(address.zip_code);
    }

    this.address = {
      address_1: this.searchAddrInfo.road_address
        ? this.searchAddrInfo.road_address
        : this.searchAddrInfo.address,
      zipcode: region[2],
      localName_1: region[0],
      localName_2: region[1],
      latitude: latlng.getLat(),
      longitude: latlng.getLng(),
    };
  }

  /**
   * @method removeMarkers
   * @description 마커 삭제
   */
  removeMarkers() {
    if (this.markers.length > 0) {
      this.markers.forEach((item: any) => {
        item.setMap(null);
      });
    }

    this.markers = [];
  }

  /**
   * @method removeMyMarker
   * @description 내 위치 마커 삭제
   */
  removeMyMarker() {
    if (this.myMarker) {
      this.myMarker.setMap(null);
    }
  }

  /**
   * @method removeSelectMarker
   * @description 내 선택 지점 마커 삭제
   */
  removeSelectMarker() {
    if (this.marker) {
      this.marker.setMap(null);
    }

    if (this.infowindow) {
      this.infowindow.close();
    }
  }

  /**
   * @method removeInfowindow
   * @description 주소정보 인포 삭제
   */
  removeInfowindow() {
    if (this.infowindowArray) {
      this.infowindowArray.forEach((item: any) => {
        item.close();
      });
    }
    this.infowindowArray = [];
  }

  registerCheck(seq: number): void {
    this.$http.get(`${api.parkinglotRegisterCheck}/${seq}`).then(
      (resp) => {
        const { code } = resp.data;
        if (code === 20000) {
          this.parkinglot = Object.assign({}, this.parkinglot, { sync: true });
        }
      },
      (error) => {
        this.showAlert({
          message: error,
        });
      }
    );
  }

  /**
   * @method boundCheck
   * @description 지도영역 변경 시 iparking 호출
   */
  boundCheck() {
    const beforeCenter = new daum.maps.LatLng(
      this.myCenter.latitude,
      this.myCenter.longitude
    );
    const swLatLng = this.map.getBounds().getSouthWest();
    const neLatLng = this.map.getBounds().getNorthEast();
    const nowSwLatLng = new daum.maps.LatLng(
      swLatLng.getLat(),
      swLatLng.getLng()
    );
    const nowNeLatLng = new daum.maps.LatLng(
      neLatLng.getLat(),
      neLatLng.getLng()
    );
    const nowBound = new daum.maps.LatLngBounds(nowSwLatLng, nowNeLatLng);

    if (!nowBound.contain(beforeCenter)) {
      this.getIparkingPark();
    }
  }

  /**
   * @method closeparkinglotview
   * @description 인근주차장리스트 닫기
   */
  closeparkinglotview(): void {
    this.mapParkingLotList = [];
  }
}
